module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_5012.b631931d.png";